<template>
  <div>{{displayNum}}</div>
</template>
<script>
    import {getDate} from "../../common/tool";
    import {getFormatNumber, getRandomDuration} from "./count";

    export default {
        name: 'CountByTotal',
        props: {
            numsConfig: Object, // 人数情况
            speed: {
                type: Array,
                default() {
                    return [5, 10];
                }
            },
        },
        data () {
            return {
                people_nums: '', // 人数
                config: {},
                day: this.numsConfig.day.replace(/-/g, '/'),
                start: this.numsConfig.start,
                lastTime: this.numsConfig.a * 1,
                totalNum: this.numsConfig.b * 1,
                startNum: this.numsConfig.c * 1,
                maxNum: this.numsConfig.d * 1,
                showTime: getDate(this.numsConfig.day + " " + this.numsConfig.start).pattern("MM月dd日 HH:mm"),
                timer: 0,
            }
        },
        computed: {
            // 优化展示数字
            displayNum() {
                return getFormatNumber(this.people_nums) + '人看过';
            },
        },
        created () {
            if(this.simple) {
                this.getNum(Date.now());
            } else {
                this.animate();
            }
        },
        watch: {
            // 监听视频的变化修改相应的人数
            numsConfig: {
                handler () {
                    // console.log("切换人数");
                    // console.log(val);
                    this.day = this.numsConfig.day.replace(/-/g, '/')
                    this.start = this.numsConfig.start
                    this.lastTime = this.numsConfig.a * 1;
                    this.totalNum = this.numsConfig.b * 1;
                    this.startNum = this.numsConfig.c * 1;
                    this.maxNum = this.numsConfig.d * 1;
                    this.showTime = getDate(this.numsConfig.day + " " + this.numsConfig.start).pattern("MM月dd日 HH:mm")
                    this.clearTimer();
                    this.people_nums = 0;
                    this.animate();
                },
                deep: true
            }
        },
        beforeDestroy() {
            this.clearTimer();
        },
        methods: {
            clearTimer() {
                if(this.timer)  {
                    clearInterval(this.timer);
                    this.timer = 0;
                }
            },
            getNum: function (now) {
                let _this = this
                _this.config.total = parseInt(_this.totalNum)
                _this.config.max = parseInt(_this.maxNum)
                _this.config.last = parseInt(_this.lastTime * 60)
                _this.config.sN = parseInt(_this.startNum)
                _this.config.start = new Date(_this.day + ' ' + _this.start).getTime()
                if (now - _this.config.start >= 0) {
                    // console.log(123);
                    let x = parseInt(new Date(now - _this.config.start).getTime() / 1000)
                    let n = 0 // 当前直播的累计观看人数
                    if (x < _this.config.last) {
                        // 直播中
                        n =
                            ((_this.config.sN - _this.config.total) /
                                Math.abs((_this.config.last * _this.config.last))) *
                            Math.abs(((x - _this.config.last) * (x - _this.config.last))) +
                            _this.config.total
                    } else {
                        // 直播结束
                        n =
                            (Math.atan(x) * (_this.config.max - _this.config.total) * 2) /
                            Math.PI +
                            _this.config.total
                    }
                    _this.people_nums = parseInt(n);
                } else {
                    _this.people_nums = 0
                }
            },
            animate: function () {
                if(this.totalNum > 0) {
                    this.getNum(Date.now())
                    this.timer = setTimeout(() => this.animate(), getRandomDuration(this.speed))
                }
            },
            getSimplifyNum(n) {
                return n > 10000 ? Math.round(n / 10000 * 10) / 10 + 'w' : parseInt(n);
            }
        }
    }
</script>
<style lang="less">
</style>
